import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 合算制度利用申出（1回目）更新API
import {
  IAPI_RET003_Request,
  IAPI_RET003_Response,
} from "../../../type/apiType";

// 合算制度利用申出（1回目）更新
// API仕様書_退職者
const httpIAPI_RET003 = async (
  param: IAPI_RET003_Request
): Promise<IAPI_RET003_Response> => {
  let res = await http.post(ApiUrl.API_RET003, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_RET003 };
